@if(isLoading$ |  async){
<div class="loader">
    <div class="spinner"></div>
</div>
}
